import { useQuery } from "@tanstack/react-query";
import { getAboutPage } from "../../api/apiAbout";

export const useGetAboutPage = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["about-page"],
        queryFn: getAboutPage,
    });

    return {
        aboutPage: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
